// @flow
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import moment from 'moment';

import { addContactReassignsDetails } from '../../redux/reducers/contactreassigns';

import Loader from '../../components/Loader/Loader';
import MessageBlock from '../../components/MessageBlock/MessageBlock';

import FormWrapper from '../../components/shared/FormWrapper';

import ContactReassignsAddForm from '../../components/ContactReassigns/Add';

class ContactReassignsAdd extends Component {
    onSubmit: Function;

    constructor(props) {
        super(props);

        this.onSubmit = this.onSubmit.bind(this);
    }

    onSubmit(formValues) {
        const { dispatch, history } = this.props;

        const contactReassignsData = {
            contactReAssignFromContactId: formValues.fromContactId,
            contactReAssignToContactId: formValues.toContactId,
            contactReAssignStartAt: formValues.startAt,
            contactReAssignRollbackedAt: formValues.rollBackAt,
        };

        return dispatch(
            addContactReassignsDetails(contactReassignsData)
        ).then(updatedContact => {
            history.push('/contacts/reassigns');
        });
    }

    render() {
        const { isFetching, errorFetching } = this.props;

        const now = new moment();
        const defaultStart = now.clone().toDate();
        // const defaultRollback = now.clone().add(7, 'days').toDate();

        const initialValues = {
            startAt: defaultStart,
            // rollBackAt: defaultRollback,
        };

        if (errorFetching) {
            return (
                <FormWrapper>
                    <MessageBlock message="An unexpected error occurred whilst loading this contact." />
                </FormWrapper>
            );
        }

        if (isFetching) {
            return (
                <FormWrapper>
                    <Loader message="Loading contact, please wait..." />
                </FormWrapper>
            );
        }

        return (
            <FormWrapper>
                <ContactReassignsAddForm
                    onSubmit={this.onSubmit}
                    initialValues={initialValues}
                />
            </FormWrapper>
        );
    }
}

const mapStateToProps = state => {
    const add = state.contactreassigns.add;

    return {
        errorFetching: add.error,
        isFetching: add.fetching,
        contactReassigns: add.contactReassigns,
    };
};

export default withRouter(connect(mapStateToProps)(ContactReassignsAdd));



// WEBPACK FOOTER //
// ./src/containers/ContactReassignsAdd/ContactReassignsAdd.js